import gql from 'graphql-tag';

export const SAVE_USER_EMAIL_CONFIGURATION = gql`
  mutation SaveUserEmailConfiguration($input: UserEmailConfigurationInput!) {
    saveUserEmailConfiguration(input: $input) {
      success
      message
      configuration {
        id
        userId
        customEmailBody
        contactDetailsInfo
        orderDetailsInfo
        repSignature
        addBillSheetAttachment
        firstName
        lastName
        title
        business
        department
        city
        phone
        emailLink
        hyperlink
        createdAt
        updatedAt
      }
    }
  }
`;
